/* eslint-disable no-underscore-dangle */
import { AddNewRolesForm, EditRole } from '../../forms';
import React, { useEffect, useState } from 'react';
import { RolesManagementService } from '../../services';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ToastBar, CircularProgressLoader, Overlay } from '../../components';


const ManageRolesComponent = () => {
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const [module, setModule] = useState<any>([]);
  const { id } = useParams();
  const location = useLocation();
  const editRoles: boolean = location.pathname.includes('editRoles');
  const [roles, setRoles] = React.useState<any>();
  const [showOverlay, setShowOverlay] = React.useState<any>();
  const [notification, setNotification] = React.useState({
    show: false,
    message: '',
  });
  const getPermissions = (data: any, key: string) => {
    let permission: any;
    data.forEach((ele: any) => {
      if (ele.moduleId && ele.moduleId.key === key) {
        permission = ele;
      }
    });
    // a role saved before the module existed (ENTER VICE, Special Posts) has no entry: nothing granted
    return permission || {};
  };
  useEffect(() => {
    setLoader(true);
    if (editRoles) {
      RolesManagementService.getDetails(id).then((res: any) => {
        setLoader(false);
        setRoles({
          roleName: res.data.data.role.role,
          usermgmt_add: getPermissions(res.data.data.permissions, 'user_mangement').add,
          usermgmt_edit: getPermissions(res.data.data.permissions, 'user_mangement').edit,
          usermgmt_delete: getPermissions(res.data.data.permissions, 'user_mangement').delete,
          channelmgmt_add: getPermissions(res.data.data.permissions, 'channel_mangement').add,
          channelmgmt_edit: getPermissions(res.data.data.permissions, 'channel_mangement').edit,
          channelmgmt_delete: getPermissions(res.data.data.permissions, 'channel_mangement').delete,
          subscriptionplanmgmt_add: getPermissions(res.data.data.permissions, 'subscription_plan_management').add,
          subscriptionplanmgmt_edit: getPermissions(res.data.data.permissions, 'subscription_plan_management').edit,
          subscriptionplanmgmt_delete: getPermissions(res.data.data.permissions, 'subscription_plan_management').delete,
          subscribedusers_add: getPermissions(res.data.data.permissions, 'subscribed_users').add,
          subscribedusers_edit: getPermissions(res.data.data.permissions, 'subscribed_users').edit,
          subscribedusers_delete: getPermissions(res.data.data.permissions, 'subscribed_users').delete,
          serviceprovidemgmt_add: getPermissions(res.data.data.permissions, 'service_provider_management').add,
          serviceprovidemgmt_edit: getPermissions(res.data.data.permissions, 'service_provider_management').edit,
          serviceprovidemgmt_delete: getPermissions(res.data.data.permissions, 'service_provider_management').delete,
          purchaseecommerce_add: getPermissions(res.data.data.permissions, 'purchase_e-commerce').add,
          purchaseecommerce_edit: getPermissions(res.data.data.permissions, 'purchase_e-commerce').edit,
          purchaseecommerce_delete: getPermissions(res.data.data.permissions, 'purchase_e-commerce').delete,
          campaignmgmt_add: getPermissions(res.data.data.permissions, 'campaign_management').add,
          campaignmgmt_edit: getPermissions(res.data.data.permissions, 'campaign_management').edit,
          campaignmgmt_delete: getPermissions(res.data.data.permissions, 'campaign_management').delete,
          promotionsadver_add: getPermissions(res.data.data.permissions, 'promotions& _advertising').add,
          promotionsadver_edit: getPermissions(res.data.data.permissions, 'promotions& _advertising').edit,
          promotionsadver_delete: getPermissions(res.data.data.permissions, 'promotions& _advertising').delete,
          sellerbrandmgmt_add: getPermissions(res.data.data.permissions, 'seller/Brand_management').add,
          sellerbrandmgmt_edit: getPermissions(res.data.data.permissions, 'seller/Brand_management').edit,
          sellerbrandmgmt_delete: getPermissions(res.data.data.permissions, 'seller/Brand_management').delete,
          livestreaming_add: getPermissions(res.data.data.permissions, 'live_streamings').add,
          livestreaming_edit: getPermissions(res.data.data.permissions, 'live_streamings').edit,
          livestreaming_delete: getPermissions(res.data.data.permissions, 'live_streamings').delete,
          reportedusermgmt_add: getPermissions(res.data.data.permissions, 'report_user_management').add,
          reportedusermgmt_edit: getPermissions(res.data.data.permissions, 'report_user_management').edit,
          reportedusermgmt_delete: getPermissions(res.data.data.permissions, 'report_user_management').delete,
          rolemgmt_add: getPermissions(res.data.data.permissions, 'role_management').add,
          rolemgmt_edit: getPermissions(res.data.data.permissions, 'role_management').edit,
          rolemgmt_delete: getPermissions(res.data.data.permissions, 'role_management').delete,
          subadminmgmt_add: getPermissions(res.data.data.permissions, 'sub-Admin_management').add,
          subadminmgmt_edit: getPermissions(res.data.data.permissions, 'sub-Admin_management').edit,
          subadminmgmt_delete: getPermissions(res.data.data.permissions, 'sub-Admin_management').delete,
          eventmgmt_add: getPermissions(res.data.data.permissions, 'event_management').add,
          eventmgmt_edit: getPermissions(res.data.data.permissions, 'event_management').edit,
          eventmgmt_delete: getPermissions(res.data.data.permissions, 'event_management').delete,
          paymentmgmt_add: getPermissions(res.data.data.permissions, 'payment_management').add,
          paymentmgmt_edit: getPermissions(res.data.data.permissions, 'payment_management').edit,
          paymentmgmt_delete: getPermissions(res.data.data.permissions, 'payment_management').delete,
          coinactivitymgmt_add: getPermissions(res.data.data.permissions, 'coin_activity_anagement').add,
          coinactivitymgmt_edit: getPermissions(res.data.data.permissions, 'coin_activity_anagement').edit,
          coinactivitymgmt_delete: getPermissions(res.data.data.permissions, 'coin_activity_anagement').delete,
          commissionmgmt_add: getPermissions(res.data.data.permissions, 'commission_management').add,
          commissionmgmt_edit: getPermissions(res.data.data.permissions, 'commission_management').edit,
          commissionmgmt_delete: getPermissions(res.data.data.permissions, 'commission_management').delete,
          rewardpoints_add: getPermissions(res.data.data.permissions, 'reward_points').add,
          rewardpoints_edit: getPermissions(res.data.data.permissions, 'reward_points').edit,
          rewardpoints_delete: getPermissions(res.data.data.permissions, 'reward_points').delete,
          categories_add: getPermissions(res.data.data.permissions, 'categories').add,
          categories_edit: getPermissions(res.data.data.permissions, 'categories').edit,
          categories_delete: getPermissions(res.data.data.permissions, 'categories').delete,
          subcategorymgmt_add: getPermissions(res.data.data.permissions, 'sub_categories').add,
          subcategorymgmt_edit: getPermissions(res.data.data.permissions, 'sub_categories').edit,
          subcategorymgmt_delete: getPermissions(res.data.data.permissions, 'sub_categories').delete,
          issuesreported_add: getPermissions(res.data.data.permissions, 'issues_reported').add,
          issuesreported_edit: getPermissions(res.data.data.permissions, 'issues_reported').edit,
          issuesreported_delete: getPermissions(res.data.data.permissions, 'issues_reported').delete,
          versionmanagement_add: getPermissions(res.data.data.permissions, 'version_management').add,
          versionmanagement_edit: getPermissions(res.data.data.permissions, 'version_management').edit,
          versionmanagement_delete: getPermissions(res.data.data.permissions, 'version_management').delete,
          reminderemails_add: getPermissions(res.data.data.permissions, 'reminder_emails').add,
          reminderemails_edit: getPermissions(res.data.data.permissions, 'reminder_emails').edit,
          reminderemails_delete: getPermissions(res.data.data.permissions, 'reminder_emails').delete,
          contentmgmt_add: getPermissions(res.data.data.permissions, 'content_management').add,
          contentmgmt_edit: getPermissions(res.data.data.permissions, 'content_management').edit,
          contentmgmt_delete: getPermissions(res.data.data.permissions, 'content_management').delete,
          notificationmmt_add: getPermissions(res.data.data.permissions, 'notification_management').add,
          notificationmmt_edit: getPermissions(res.data.data.permissions, 'notification_management').edit,
          notificationmmt_delete: getPermissions(res.data.data.permissions, 'notification_management').delete,
          support_add: getPermissions(res.data.data.permissions, 'support').add,
          support_edit: getPermissions(res.data.data.permissions, 'support').edit,
          support_delete: getPermissions(res.data.data.permissions, 'support').delete,
          feedback_add: getPermissions(res.data.data.permissions, 'feedback').add,
          feedback_edit: getPermissions(res.data.data.permissions, 'feedback').edit,
          feedback_delete: getPermissions(res.data.data.permissions, 'feedback').delete,
          reportmgmt_add: getPermissions(res.data.data.permissions, 'report_management').add,
          reportmgmt_edit: getPermissions(res.data.data.permissions, 'report_management').edit,
          reportmgmt_delete: getPermissions(res.data.data.permissions, 'report_management').delete,
          landing_add: getPermissions(res.data.data.permissions, 'landing').add,
          landing_edit: getPermissions(res.data.data.permissions, 'landing').edit,
          landing_delete: getPermissions(res.data.data.permissions, 'landing').delete,
          thea_add: getPermissions(res.data.data.permissions, 'thea').add,
          thea_edit: getPermissions(res.data.data.permissions, 'thea').edit,
          thea_delete: getPermissions(res.data.data.permissions, 'thea').delete,
          entervice_add: getPermissions(res.data.data.permissions, 'entervice').add,
          entervice_edit: getPermissions(res.data.data.permissions, 'entervice').edit,
          entervice_delete: getPermissions(res.data.data.permissions, 'entervice').delete,
          specialposts_add: getPermissions(res.data.data.permissions, 'special_posts').add,
          specialposts_edit: getPermissions(res.data.data.permissions, 'special_posts').edit,
          specialposts_delete: getPermissions(res.data.data.permissions, 'special_posts').delete,
        });
      });
    }
    RolesManagementService.getModulesList().then((res) => {
      const data: any = [];
      setLoader(false);
      res.data.data.forEach((ele: any) => {
        data.push({ key: ele._id, label: ele.key });
      });
      setModule(data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getModuleId = (str: any) => {
    let keyValue: any;
    module.forEach((ele: any) => {
      if (ele.label === str) {
        keyValue = ele.key;
      }
    });
    return keyValue;
  };
  const handleSubmitForm = (data: any) => {
    setShowOverlay(true);
    if (data.roleName.toString().toLowerCase() === 'super admin' || data.roleName.toString().toLowerCase() === 'superadmin') {
      setNotification({
        ...notification,
        show: true,
        message: 'Role Name cannot be super Admin',
      });
      setShowOverlay(false);
    } else {
      const newRole = {
        role: data.roleName,
        permissions: [{
          moduleId: getModuleId('user_mangement'),
          add: data.usermgmt_add,
          edit: data.usermgmt_edit,
          delete: data.usermgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('landing'),
          add: data.landing_add,
          edit: data.landing_edit,
          delete: data.landing_delete,
          view: true,
        },
        {
          moduleId: getModuleId('thea'),
          add: data.thea_add,
          edit: data.thea_edit,
          delete: data.thea_delete,
          view: true,
        },
        {
          moduleId: getModuleId('entervice'),
          add: data.entervice_add,
          edit: data.entervice_edit,
          delete: data.entervice_delete,
          view: true,
        },
        {
          moduleId: getModuleId('special_posts'),
          add: data.specialposts_add,
          edit: data.specialposts_edit,
          delete: data.specialposts_delete,
          view: true,
        },
        {
          moduleId: getModuleId('channel_mangement'),
          add: data.channelmgmt_add,
          edit: data.channelmgmt_edit,
          delete: data.channelmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('subscription_plan_management'),
          add: data.subscriptionplanmgmt_add,
          edit: data.subscriptionplanmgmt_edit,
          delete: data.subscriptionplanmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('subscribed_users'),
          add: data.subscribedusers_add,
          edit: data.subscribedusers_edit,
          delete: data.subscribedusers_delete,
          view: true,
        },
        {
          moduleId: getModuleId('service_provider_management'),
          add: data.serviceprovidemgmt_add,
          edit: data.serviceprovidemgmt_edit,
          delete: data.serviceprovidemgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('purchase_e-commerce'),
          add: data.purchaseecommerce_add,
          edit: data.purchaseecommerce_edit,
          delete: data.purchaseecommerce_delete,
          view: true,
        },
        {
          moduleId: getModuleId('campaign_management'),
          add: data.campaignmgmt_add,
          edit: data.campaignmgmt_edit,
          delete: data.campaignmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('promotions& _advertising'),
          add: data.promotionsadver_add,
          edit: data.promotionsadver_edit,
          delete: data.promotionsadver_delete,
          view: true,
        },
        {
          moduleId: getModuleId('seller/Brand_management'),
          add: data.sellerbrandmgmt_add,
          edit: data.sellerbrandmgmt_edit,
          delete: data.sellerbrandmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('live_streamings'),
          add: data.livestreaming_add,
          edit: data.livestreaming_edit,
          delete: data.livestreaming_delete,
          view: true,
        },
        {
          moduleId: getModuleId('report_user_management'),
          add: data.reportedusermgmt_add,
          edit: data.reportedusermgmt_edit,
          delete: data.reportedusermgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('role_management'),
          add: data.rolemgmt_add,
          edit: data.rolemgmt_edit,
          delete: data.rolemgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('sub-Admin_management'),
          add: data.subadminmgmt_add,
          edit: data.subadminmgmt_edit,
          delete: data.subadminmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('event_management'),
          add: data.eventmgmt_add,
          edit: data.eventmgmt_edit,
          delete: data.eventmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('payment_management'),
          add: data.paymentmgmt_add,
          edit: data.paymentmgmt_edit,
          delete: data.paymentmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('coin_activity_anagement'),
          add: data.coinactivitymgmt_add,
          edit: data.coinactivitymgmt_edit,
          delete: data.coinactivitymgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('commission_management'),
          add: data.commissionmgmt_add,
          edit: data.commissionmgmt_edit,
          delete: data.commissionmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('reward_points'),
          add: data.rewardpoints_add,
          edit: data.rewardpoints_edit,
          delete: data.rewardpoints_delete,
          view: true,
        },
        {
          moduleId: getModuleId('categories'),
          add: data.categories_add,
          edit: data.categories_edit,
          delete: data.categories_delete,
          view: true,
        },
        {
          moduleId: getModuleId('sub_categories'),
          add: data.subcategorymgmt_add,
          edit: data.subcategorymgmt_edit,
          delete: data.subcategorymgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('issues_reported'),
          add: data.issuesreported_add,
          edit: data.issuesreported_edit,
          delete: data.issuesreported_delete,
          view: true,
        },
        {
          moduleId: getModuleId('version_management'),
          add: data.versionmanagement_add,
          edit: data.versionmanagement_edit,
          delete: data.versionmanagement_delete,
          view: true,
        }, {
          moduleId: getModuleId('reminder_emails'),
          add: data.reminderemails_add,
          edit: data.reminderemails_edit,
          delete: data.reminderemails_delete,
          view: true,
        },
        {
          moduleId: getModuleId('content_management'),
          add: data.contentmgmt_add,
          edit: data.contentmgmt_edit,
          delete: data.contentmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('notification_management'),
          add: data.notificationmmt_add,
          edit: data.notificationmmt_edit,
          delete: data.notificationmmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('support'),
          add: data.support_add,
          edit: data.support_edit,
          delete: data.support_delete,
          view: true,
        },
        {
          moduleId: getModuleId('feedback'),
          add: data.feedback_add,
          edit: data.feedback_edit,
          delete: data.feedback_delete,
          view: true,
        },
        {
          moduleId: getModuleId('report_management'),
          add: data.reportmgmt_add,
          edit: data.reportmgmt_edit,
          delete: data.reportmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('dashboard_management'),
          add: true,
          edit: true,
          delete: true,
          view: true,
        },
        ],
      };
      RolesManagementService.addRole(newRole).then(() => {
        navigate('/rolemanagement');
        setShowOverlay(false);
      }).catch((err: any) => {
        setShowOverlay(false);
        setNotification({
          ...notification,
          show: true,
          message: err.response.data.message,
        });
      });
    }
  };
  const handleUpdateForm = (data: any) => {
    setShowOverlay(true);
    if (data.roleName.toString().toLowerCase() === 'super admin' || data.roleName.toString().toLowerCase() === 'superadmin') {
      setNotification({
        ...notification,
        show: true,
        message: 'Role Name cannot be super Admin',
      });
      setShowOverlay(false);
    } else {
      const newRole = {
        role: data.roleName,
        status: 'unblocked',
        permissions: [{
          moduleId: getModuleId('user_mangement'),
          add: data.usermgmt_add,
          edit: data.usermgmt_edit,
          delete: data.usermgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('landing'),
          add: data.landing_add,
          edit: data.landing_edit,
          delete: data.landing_delete,
          view: true,
        },
        {
          moduleId: getModuleId('thea'),
          add: data.thea_add,
          edit: data.thea_edit,
          delete: data.thea_delete,
          view: true,
        },
        {
          moduleId: getModuleId('entervice'),
          add: data.entervice_add,
          edit: data.entervice_edit,
          delete: data.entervice_delete,
          view: true,
        },
        {
          moduleId: getModuleId('special_posts'),
          add: data.specialposts_add,
          edit: data.specialposts_edit,
          delete: data.specialposts_delete,
          view: true,
        },
        {
          moduleId: getModuleId('channel_mangement'),
          add: data.channelmgmt_add,
          edit: data.channelmgmt_edit,
          delete: data.channelmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('subscription_plan_management'),
          add: data.subscriptionplanmgmt_add,
          edit: data.subscriptionplanmgmt_edit,
          delete: data.subscriptionplanmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('subscribed_users'),
          add: data.subscribedusers_add,
          edit: data.subscribedusers_edit,
          delete: data.subscribedusers_delete,
          view: true,
        },
        {
          moduleId: getModuleId('service_provider_management'),
          add: data.serviceprovidemgmt_add,
          edit: data.serviceprovidemgmt_edit,
          delete: data.serviceprovidemgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('purchase_e-commerce'),
          add: data.purchaseecommerce_add,
          edit: data.purchaseecommerce_edit,
          delete: data.purchaseecommerce_delete,
          view: true,
        },
        {
          moduleId: getModuleId('campaign_management'),
          add: data.campaignmgmt_add,
          edit: data.campaignmgmt_edit,
          delete: data.campaignmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('promotions& _advertising'),
          add: data.promotionsadver_add,
          edit: data.promotionsadver_edit,
          delete: data.promotionsadver_delete,
          view: true,
        },
        {
          moduleId: getModuleId('seller/Brand_management'),
          add: data.sellerbrandmgmt_add,
          edit: data.sellerbrandmgmt_edit,
          delete: data.sellerbrandmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('live_streamings'),
          add: data.livestreaming_add,
          edit: data.livestreaming_edit,
          delete: data.livestreaming_delete,
          view: true,
        },
        {
          moduleId: getModuleId('report_user_management'),
          add: data.reportedusermgmt_add,
          edit: data.reportedusermgmt_edit,
          delete: data.reportedusermgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('role_management'),
          add: data.rolemgmt_add,
          edit: data.rolemgmt_edit,
          delete: data.rolemgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('sub-Admin_management'),
          add: data.subadminmgmt_add,
          edit: data.subadminmgmt_edit,
          delete: data.subadminmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('event_management'),
          add: data.eventmgmt_add,
          edit: data.eventmgmt_edit,
          delete: data.eventmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('payment_management'),
          add: data.paymentmgmt_add,
          edit: data.paymentmgmt_edit,
          delete: data.paymentmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('coin_activity_anagement'),
          add: data.coinactivitymgmt_add,
          edit: data.coinactivitymgmt_edit,
          delete: data.coinactivitymgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('commission_management'),
          add: data.commissionmgmt_add,
          edit: data.commissionmgmt_edit,
          delete: data.commissionmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('reward_points'),
          add: data.rewardpoints_add,
          edit: data.rewardpoints_edit,
          delete: data.rewardpoints_delete,
          view: true,
        },
        {
          moduleId: getModuleId('categories'),
          add: data.categories_add,
          edit: data.categories_edit,
          delete: data.categories_delete,
          view: true,
        },
        {
          moduleId: getModuleId('sub_categories'),
          add: data.subcategorymgmt_add,
          edit: data.subcategorymgmt_edit,
          delete: data.subcategorymgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('issues_reported'),
          add: data.issuesreported_add,
          edit: data.issuesreported_edit,
          delete: data.issuesreported_delete,
          view: true,
        },
        {
          moduleId: getModuleId('version_management'),
          add: data.versionmanagement_add,
          edit: data.versionmanagement_edit,
          delete: data.versionmanagement_delete,
          view: true,
        }, {
          moduleId: getModuleId('reminder_emails'),
          add: data.reminderemails_add,
          edit: data.reminderemails_edit,
          delete: data.reminderemails_delete,
          view: true,
        },
        {
          moduleId: getModuleId('content_management'),
          add: data.contentmgmt_add,
          edit: data.contentmgmt_edit,
          delete: data.contentmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('notification_management'),
          add: data.notificationmmt_add,
          edit: data.notificationmmt_edit,
          delete: data.notificationmmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('support'),
          add: data.support_add,
          edit: data.support_edit,
          delete: data.support_delete,
          view: true,
        },
        {
          moduleId: getModuleId('feedback'),
          add: data.feedback_add,
          edit: data.feedback_edit,
          delete: data.feedback_delete,
          view: true,
        },
        {
          moduleId: getModuleId('report_management'),
          add: data.reportmgmt_add,
          edit: data.reportmgmt_edit,
          delete: data.reportmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('dashboard_management'),
          add: true,
          edit: true,
          delete: true,
          view: true,
        },
        ],
      };
      RolesManagementService.updateRoles({ roleId: id, ...newRole })
        .then(() => {
          navigate('/rolemanagement');
        })
        .catch((err: any) => {
          setShowOverlay(false);
          setNotification({
            ...notification,
            show: true,
            message: err.response.data.message,
          });
        });
    }
  };
  const handleSaveAsDraftForAdd = (e: any, data: any) => {
    e.preventDefault();
    setShowOverlay(true);
    if (data.roleName.toString().toLowerCase() === 'super admin' || data.roleName.toString().toLowerCase() === 'superadmin') {
      setNotification({
        ...notification,
        show: true,
        message: 'Role Name cannot be super Admin',
      });
      setShowOverlay(false);
    } else {
      const newRole = {
        role: data.roleName,
        permissions: [{
          moduleId: getModuleId('user_mangement'),
          add: data.usermgmt_add,
          edit: data.usermgmt_edit,
          delete: data.usermgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('landing'),
          add: data.landing_add,
          edit: data.landing_edit,
          delete: data.landing_delete,
          view: true,
        },
        {
          moduleId: getModuleId('thea'),
          add: data.thea_add,
          edit: data.thea_edit,
          delete: data.thea_delete,
          view: true,
        },
        {
          moduleId: getModuleId('entervice'),
          add: data.entervice_add,
          edit: data.entervice_edit,
          delete: data.entervice_delete,
          view: true,
        },
        {
          moduleId: getModuleId('special_posts'),
          add: data.specialposts_add,
          edit: data.specialposts_edit,
          delete: data.specialposts_delete,
          view: true,
        },
        {
          moduleId: getModuleId('channel_mangement'),
          add: data.channelmgmt_add,
          edit: data.channelmgmt_edit,
          delete: data.channelmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('subscription_plan_management'),
          add: data.subscriptionplanmgmt_add,
          edit: data.subscriptionplanmgmt_edit,
          delete: data.subscriptionplanmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('subscribed_users'),
          add: data.subscribedusers_add,
          edit: data.subscribedusers_edit,
          delete: data.subscribedusers_delete,
          view: true,
        },
        {
          moduleId: getModuleId('service_provider_management'),
          add: data.serviceprovidemgmt_add,
          edit: data.serviceprovidemgmt_edit,
          delete: data.serviceprovidemgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('purchase_e-commerce'),
          add: data.purchaseecommerce_add,
          edit: data.purchaseecommerce_edit,
          delete: data.purchaseecommerce_delete,
          view: true,
        },
        {
          moduleId: getModuleId('campaign_management'),
          add: data.campaignmgmt_add,
          edit: data.campaignmgmt_edit,
          delete: data.campaignmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('promotions& _advertising'),
          add: data.promotionsadver_add,
          edit: data.promotionsadver_edit,
          delete: data.promotionsadver_delete,
          view: true,
        },
        {
          moduleId: getModuleId('seller/Brand_management'),
          add: data.sellerbrandmgmt_add,
          edit: data.sellerbrandmgmt_edit,
          delete: data.sellerbrandmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('live_streamings'),
          add: data.livestreaming_add,
          edit: data.livestreaming_edit,
          delete: data.livestreaming_delete,
          view: true,
        },
        {
          moduleId: getModuleId('report_user_management'),
          add: data.reportedusermgmt_add,
          edit: data.reportedusermgmt_edit,
          delete: data.reportedusermgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('role_management'),
          add: data.rolemgmt_add,
          edit: data.rolemgmt_edit,
          delete: data.rolemgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('sub-Admin_management'),
          add: data.subadminmgmt_add,
          edit: data.subadminmgmt_edit,
          delete: data.subadminmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('event_management'),
          add: data.eventmgmt_add,
          edit: data.eventmgmt_edit,
          delete: data.eventmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('payment_management'),
          add: data.paymentmgmt_add,
          edit: data.paymentmgmt_edit,
          delete: data.paymentmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('coin_activity_anagement'),
          add: data.coinactivitymgmt_add,
          edit: data.coinactivitymgmt_edit,
          delete: data.coinactivitymgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('commission_management'),
          add: data.commissionmgmt_add,
          edit: data.commissionmgmt_edit,
          delete: data.commissionmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('reward_points'),
          add: data.rewardpoints_add,
          edit: data.rewardpoints_edit,
          delete: data.rewardpoints_delete,
          view: true,
        },
        {
          moduleId: getModuleId('categories'),
          add: data.categories_add,
          edit: data.categories_edit,
          delete: data.categories_delete,
          view: true,
        },
        {
          moduleId: getModuleId('sub_categories'),
          add: data.subcategorymgmt_add,
          edit: data.subcategorymgmt_edit,
          delete: data.subcategorymgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('issues_reported'),
          add: data.issuesreported_add,
          edit: data.issuesreported_edit,
          delete: data.issuesreported_delete,
          view: true,
        },
        {
          moduleId: getModuleId('version_management'),
          add: data.versionmanagement_add,
          edit: data.versionmanagement_edit,
          delete: data.versionmanagement_delete,
          view: true,
        }, {
          moduleId: getModuleId('reminder_emails'),
          add: data.reminderemails_add,
          edit: data.reminderemails_edit,
          delete: data.reminderemails_delete,
          view: true,
        },
        {
          moduleId: getModuleId('content_management'),
          add: data.contentmgmt_add,
          edit: data.contentmgmt_edit,
          delete: data.contentmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('notification_management'),
          add: data.notificationmmt_add,
          edit: data.notificationmmt_edit,
          delete: data.notificationmmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('support'),
          add: data.support_add,
          edit: data.support_edit,
          delete: data.support_delete,
          view: true,
        },
        {
          moduleId: getModuleId('feedback'),
          add: data.feedback_add,
          edit: data.feedback_edit,
          delete: data.feedback_delete,
          view: true,
        },
        {
          moduleId: getModuleId('report_management'),
          add: data.reportmgmt_add,
          edit: data.reportmgmt_edit,
          delete: data.reportmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('dashboard_management'),
          add: true,
          edit: true,
          delete: true,
          view: true,
        },
        ],
        status: 'draft',
      };
      RolesManagementService.saveAsDraftEdit(newRole).then(() => {
        navigate('/rolemanagement');
      }).catch((err: any) => {
        setShowOverlay(false);
        setNotification({
          ...notification,
          show: true,
          message: err.response.data.message,
        });
      });
    }
  };
  const handleSaveAsDraftForEdit = (e: any, data: any) => {
    e.preventDefault();
    setShowOverlay(true);
    if (data.roleName.toString().toLowerCase() === 'super admin' || data.roleName.toString().toLowerCase() === 'superadmin') {
      setNotification({
        ...notification,
        show: true,
        message: 'Role Name cannot be super Admin',
      });
      setShowOverlay(false);
    } else {
      const newRole = {
        role: data.roleName,
        roleId: id,
        permissions: [{
          moduleId: getModuleId('user_mangement'),
          add: data.usermgmt_add,
          edit: data.usermgmt_edit,
          delete: data.usermgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('landing'),
          add: data.landing_add,
          edit: data.landing_edit,
          delete: data.landing_delete,
          view: true,
        },
        {
          moduleId: getModuleId('thea'),
          add: data.thea_add,
          edit: data.thea_edit,
          delete: data.thea_delete,
          view: true,
        },
        {
          moduleId: getModuleId('entervice'),
          add: data.entervice_add,
          edit: data.entervice_edit,
          delete: data.entervice_delete,
          view: true,
        },
        {
          moduleId: getModuleId('special_posts'),
          add: data.specialposts_add,
          edit: data.specialposts_edit,
          delete: data.specialposts_delete,
          view: true,
        },
        {
          moduleId: getModuleId('channel_mangement'),
          add: data.channelmgmt_add,
          edit: data.channelmgmt_edit,
          delete: data.channelmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('subscription_plan_management'),
          add: data.subscriptionplanmgmt_add,
          edit: data.subscriptionplanmgmt_edit,
          delete: data.subscriptionplanmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('subscribed_users'),
          add: data.subscribedusers_add,
          edit: data.subscribedusers_edit,
          delete: data.subscribedusers_delete,
          view: true,
        },
        {
          moduleId: getModuleId('service_provider_management'),
          add: data.serviceprovidemgmt_add,
          edit: data.serviceprovidemgmt_edit,
          delete: data.serviceprovidemgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('purchase_e-commerce'),
          add: data.purchaseecommerce_add,
          edit: data.purchaseecommerce_edit,
          delete: data.purchaseecommerce_delete,
          view: true,
        },
        {
          moduleId: getModuleId('campaign_management'),
          add: data.campaignmgmt_add,
          edit: data.campaignmgmt_edit,
          delete: data.campaignmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('promotions& _advertising'),
          add: data.promotionsadver_add,
          edit: data.promotionsadver_edit,
          delete: data.promotionsadver_delete,
          view: true,
        },
        {
          moduleId: getModuleId('seller/Brand_management'),
          add: data.sellerbrandmgmt_add,
          edit: data.sellerbrandmgmt_edit,
          delete: data.sellerbrandmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('live_streamings'),
          add: data.livestreaming_add,
          edit: data.livestreaming_edit,
          delete: data.livestreaming_delete,
          view: true,
        },
        {
          moduleId: getModuleId('report_user_management'),
          add: data.reportedusermgmt_add,
          edit: data.reportedusermgmt_edit,
          delete: data.reportedusermgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('role_management'),
          add: data.rolemgmt_add,
          edit: data.rolemgmt_edit,
          delete: data.rolemgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('sub-Admin_management'),
          add: data.subadminmgmt_add,
          edit: data.subadminmgmt_edit,
          delete: data.subadminmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('event_management'),
          add: data.eventmgmt_add,
          edit: data.eventmgmt_edit,
          delete: data.eventmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('payment_management'),
          add: data.paymentmgmt_add,
          edit: data.paymentmgmt_edit,
          delete: data.paymentmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('coin_activity_anagement'),
          add: data.coinactivitymgmt_add,
          edit: data.coinactivitymgmt_edit,
          delete: data.coinactivitymgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('commission_management'),
          add: data.commissionmgmt_add,
          edit: data.commissionmgmt_edit,
          delete: data.commissionmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('reward_points'),
          add: data.rewardpoints_add,
          edit: data.rewardpoints_edit,
          delete: data.rewardpoints_delete,
          view: true,
        },
        {
          moduleId: getModuleId('categories'),
          add: data.categories_add,
          edit: data.categories_edit,
          delete: data.categories_delete,
          view: true,
        },
        {
          moduleId: getModuleId('sub_categories'),
          add: data.subcategorymgmt_add,
          edit: data.subcategorymgmt_edit,
          delete: data.subcategorymgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('issues_reported'),
          add: data.issuesreported_add,
          edit: data.issuesreported_edit,
          delete: data.issuesreported_delete,
          view: true,
        },
        {
          moduleId: getModuleId('version_management'),
          add: data.versionmanagement_add,
          edit: data.versionmanagement_edit,
          delete: data.versionmanagement_delete,
          view: true,
        }, {
          moduleId: getModuleId('reminder_emails'),
          add: data.reminderemails_add,
          edit: data.reminderemails_edit,
          delete: data.reminderemails_delete,
          view: true,
        },
        {
          moduleId: getModuleId('content_management'),
          add: data.contentmgmt_add,
          edit: data.contentmgmt_edit,
          delete: data.contentmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('notification_management'),
          add: data.notificationmmt_add,
          edit: data.notificationmmt_edit,
          delete: data.notificationmmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('support'),
          add: data.support_add,
          edit: data.support_edit,
          delete: data.support_delete,
          view: true,
        },
        {
          moduleId: getModuleId('feedback'),
          add: data.feedback_add,
          edit: data.feedback_edit,
          delete: data.feedback_delete,
          view: true,
        },
        {
          moduleId: getModuleId('report_management'),
          add: data.reportmgmt_add,
          edit: data.reportmgmt_edit,
          delete: data.reportmgmt_delete,
          view: true,
        },
        {
          moduleId: getModuleId('dashboard_management'),
          add: true,
          edit: true,
          delete: true,
          view: true,
        },
        ],
        status: 'draft',
      };
      RolesManagementService.saveAsDraftForEdit(newRole).then(() => {
        navigate('/rolemanagement');
      }).catch((err: any) => {
        setShowOverlay(false);
        setNotification({
          ...notification,
          show: true,
          message: err.response.data.message,
        });
      });
    }
  };
  return (
    <>
      {showOverlay && <Overlay />}
      {notification.show && (
        <ToastBar
          message={notification.message}
          handleCloseMethod={() => setNotification({
            ...notification,
            show: false,
            message: '',
          })}
        />
      )}
      {loader ? <CircularProgressLoader /> : (
        <>
          {editRoles ? (
            <EditRole
              handleSubmit={handleUpdateForm}
              handleSaveAsDraft={handleSaveAsDraftForEdit}
              loader={loader}
              roles={roles}
            />
          ) : (
            <AddNewRolesForm
              handleSubmit={handleSubmitForm}
              handleSaveAsDraft={handleSaveAsDraftForAdd}
              loader={loader}
            />
          )}
        </>
      )}
    </>
  );
};

export default ManageRolesComponent;
